export default "__VITE_ASSET__CrlCOHFM__"